import React, { useEffect, useState } from 'react';

interface TourWidgetProps {
  onStartTour: () => void;
}

const TourWidget: React.FC<TourWidgetProps> = ({ onStartTour }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [shouldBounce, setShouldBounce] = useState(false);

  useEffect(() => {
    const isFirstAppLoad = localStorage.getItem('rad-receiving-first-load');
    if (!isFirstAppLoad) {
      setShouldBounce(true);
      localStorage.setItem('rad-receiving-first-load', 'true');
    }
  }, []);

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 50, zIndex: 1000 }}>
      {tooltipOpen && (
        <div
          style={{
            position: 'absolute',
            bottom: 60,
            right: 0,
            backgroundColor: '#fff',
            padding: '20px 12px',
            borderRadius: 16,
            maxWidth: 240,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}
        >
          <div style={{ marginBottom: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>🐈</div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
              <h4 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>
                Digital Journey Navigator
              </h4>
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 12,
                  padding: '2px 6px',
                  backgroundColor: 'rgba(0, 0, 0, 0.08)',
                  borderRadius: 4,
                  color: '#666',
                }}
              >
                Beta
              </span>
            </div>
            <p style={{ margin: 0, fontSize: 12, color: '#666', lineHeight: 1.5 }}>
              Learn how to process repair returns step by step
            </p>
          </div>

          <button
            onClick={() => {
              onStartTour();
              setTooltipOpen(false);
            }}
            style={{
              width: '100%',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 12,
              padding: '10px 16px',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 600,
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.2)';
            }}
          >
            Start Tour
          </button>
        </div>
      )}

      <button
        style={{
          width: 48,
          height: 48,
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          animation: shouldBounce ? 'bounce 1s ease-in-out 3' : 'none',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
        }}
        title="Digital Journey Navigator"
        onClick={() => setTooltipOpen(!tooltipOpen)}
      >
        🐈
      </button>

      <style>{`
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
      `}</style>
    </div>
  );
};

export default TourWidget;
